import { defineComponent } from 'vue'
import { BModal } from "bootstrap-vue"
import { TranslateResult } from "vue-i18n"

import { TaskLifecycleStates } from "@skinsoft/types"
import { UPDATE_NUMBER_OF_HIGHLIGHTS_TOPIC } from "../../../busTopics"
import { reactiveVueMixin } from "@skinsoft/reactive-vue"

export const AdvanceTaskModal = defineComponent({
    mixins: [reactiveVueMixin],
    props: ['task', 'targetLifecycle'],
    template: require('./advance-task-modal.html'),
    data() {
        return {
            mounted: false,
            canBeClosed: false,
        }
    },
    computed: {
        message(): TranslateResult {
            switch (this.targetLifecycle) {
                case TaskLifecycleStates.IN_PROGRESS:
                    return this.$t('advanceTask.modal.startTask')
                case TaskLifecycleStates.PLANNED:
                    return this.$t('advanceTask.modal.replanTask')
                default:
                    return this.$t('advanceTask.modal.terminateTask')
            }
        },
    },
    methods: {
        open() {
            (this.$refs.modal as InstanceType<typeof BModal>).show();
        },

        onShow() {
            this.mounted = true
        },

        onHide() {
            this.canBeClosed = false;
            this.mounted = false;
        },

        async advance() {
            await this.$taskDataStore.transitionTask(this.task, this.targetLifecycle)
            this.emitOnBus(UPDATE_NUMBER_OF_HIGHLIGHTS_TOPIC)
            this.$emit('refresh')
            this.onHide()
        },
    },
    watch: {
        mounted(value: boolean) {
            this.$emit('mounted', value);
        },
    },
})
